module.exports = __webpack_public_path__ + "de18fb276d8761b0e793d183b109dad1.svg";